import { httpGet } from '../services'

const initiativeReportApi = {
	getInitiativeTypesList(clubId) {
		return httpGet(`/analytics/initiativeTypes/${clubId}`)
	},
}

export default initiativeReportApi
